import { API_CONFIG_URLS } from "../constants/config";
import ApiService from "../services/ApiService";


async function getNotificationListings(queryParams?: any) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.NOTIFICATIONS.GET_NOTIFICATION_LISTINGS}`,
    queryParams
  );
  return response;
}

async function getNotificationCount() {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.NOTIFICATIONS.NOTIFICATION_COUNT}`,
  );
  return response;
}


async function notificationMarkAsRead(payload?: any) {
  const response = await ApiService.patch(
    `${API_CONFIG_URLS.NOTIFICATIONS.MARK_ALL_AS_READ}`,
    payload
  );
  return response;
}
 


export const NotificationApiService = {
  getNotificationListings,
  getNotificationCount,
  notificationMarkAsRead,
};